(function () {
  'use strict';

  angular
    .module('app.exposureReportBestExposure')
    .controller('exposureReportBestExposureCtrl', ['measureService', 'exposureReportBestExposureService', '$scope','$rootScope','$http','$filter','filterFilter', '$state', 'adminService', '$location', 
                                    function (measureService, exposureReportBestExposureService, $scope, $rootScope, $http, $filter, filterFilter, $state, adminService, $location) {

      $scope.$on('refreshDashboard', function(event, args) {
          getDataExposureReportBestExposure();
      });
 
      var pieChartConfig = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 16
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '80%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          style: {
            fontSize: '16px',
            color: '#4B5567',
            fontFamily: 'ProximaNovaRegular'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };

      function getExposures(args) {
        exposureReportBestExposureService.getExposures(args)
        .then(function (data) {
          genExposures(data.exposures);
          genBestPerformingExposures(data.bestPreformingExposures);
        })
        .catch(function (msg) {
          $scope.exposures = {};
          $scope.bestPreformingExposures = [];
        })
        .finally(function () {
          $rootScope.$broadcast('sectionLoaded');
        });
      }

      function genExposures(exposures){
        $scope.exposures = exposures;
      } 

      function genBestPerformingExposures(bestPreformingExposures){
        $scope.bestPreformingExposures = bestPreformingExposures;
          var tempConfig = angular.copy(pieChartConfig);
          tempConfig.options.chart = {
            type: 'pie',
            zoomType: 'x',
            backgroundColor: null,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            width: 40,
            height: 40,
            style: {
              "overflow" : "visible"
            }
          };
          tempConfig.options.tooltip = {
            useHTML: true,
            followPointer: false,
            hideDelay: 0,
            backgroundColor: "#333b48",
            headerFormat: "",
            borderRadius: 24,
            borderWidth: 0,
            shadow: false,
            shape: "callout",
            style: {
                "color": "#FFFFFF",
                "padding": "6"
            },
            positioner: function(boxWidth, boxHeight, point) {      
                var chart = this.chart,
                plotLeft = chart.plotLeft,
                plotTop = chart.plotTop,
                plotWidth = chart.plotWidth,
                plotHeight = chart.plotHeight;
                return {x:chart.plotLeft + chart.plotWidth/2 - boxWidth/2, y:chart.plotTop - boxHeight/2 - 20};         
            },
            pointFormatter: function () {
              if(this.name == 'Other'){
                if(this.series.points[0].name == 'Impact') {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                } else {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                }
                
              } else {
                if(this.name == 'Impact') {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                } else {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                }
                
              }
            }
          };
          tempConfig.series[0] = {
            size: '31',
            innerSize: '25',
            states: {
              hover: {
                halo: {
                  size: 1
                }
              }
            }
          };

          var item = {};
          _.forEach(bestPreformingExposures.contents, function (content) {
            item = content.pieCharts;
            // reach
            item.reach.pieChartConfig = angular.copy(tempConfig);
            item.reach.pieChartConfig.series[0].name = item.name;
            item.reach.pieChartConfig.series[0].data = [{name: 'Reach', color: '#FF6C9D', y: _.get(item, 'reach.percent'), value: _.get(item, 'reach.value')},
                                                        {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'reach.percent')), value: _.get(item, 'reach.other')}];

            // engagement
            item.engagement.pieChartConfig = angular.copy(tempConfig);
            item.engagement.pieChartConfig.series[0].name = item.name;
            item.engagement.pieChartConfig.series[0].data = [{name: 'Engagement', color: '#00D6EF', y: _.get(item, 'engagement.percent'), value: _.get(item, 'engagement.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'engagement.percent')), value: _.get(item, 'engagement.other')}];

            // impact
            item.impact.pieChartConfig = angular.copy(tempConfig);
            item.impact.pieChartConfig.series[0].name = item.name;
            item.impact.pieChartConfig.series[0].data = [{name: 'Impact', color: '#4A5568', y: _.get(item, 'impact.percent'), value: _.get(item, 'impact.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'impact.percent')), value: _.get(item, 'impact.other')}];

            item.reach.value = item.reach.value;
            item.engagement.value = item.engagement.value;

            item = {};
          });
      }

      function getDataExposureReportBestExposure() {
        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
          return;
        }
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getExposures(params);
      }

      $scope.postOverviewPage = function(index){
        $rootScope.previousPagePost = $location.absUrl();
          var module;
          var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + index.relativepath;
          $http.get(url_getPlatform)
              .success(function (response) {
                  if (response.data == 1) {
                      $state.transitionTo('home.blogPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 2) {
                      $state.transitionTo('home.instagramPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 6) {
                      $state.transitionTo('home.youtubePostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 7) {
                      $state.transitionTo('home.facebookPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  }
          })
      }

      $scope.influencerOverviewPage = function(influencer_id){
        $rootScope.previousPage = $location.absUrl();
          $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
              reload: false,
              inherit: true,
              notify: true
          });
      }


      $scope.PlatformIcon = function (platform_id) {
          return adminService.getPlatformIcon(platform_id);
      }

      // first initiating
      getDataExposureReportBestExposure();
      
    }]);

})();